(()=>{
  const init=(root)=>{
    if(!root||root.dataset.topfinelTabsInitialized==="true")return;
    root.dataset.topfinelTabsInitialized="true";
    const tabs=[...root.querySelectorAll("[data-topfinel-tab]")];
    const panels=[...root.querySelectorAll("[data-topfinel-panel]")];
    if(!tabs.length||!panels.length)return;
    const activate=(value,focus=false)=>{
      tabs.forEach(tab=>{
        const active=tab.dataset.tab===value;
        tab.setAttribute("aria-selected",String(active));
        tab.tabIndex=active?0:-1;
        if(active&&focus)tab.focus({preventScroll:true});
      });
      panels.forEach(panel=>panel.hidden=panel.dataset.tab!==value);
      const current=tabs.find(tab=>tab.dataset.tab===value);
      if(current)current.scrollIntoView({behavior:"smooth",block:"nearest",inline:"nearest"});
    };
    const activateFromHash=()=>{
      const hash=window.location.hash.slice(1);
      const target=tabs.find(tab=>tab.dataset.topfinelAnchor===hash);
      if(target){
        activate(target.dataset.tab);
        window.requestAnimationFrame(()=>target.scrollIntoView({behavior:"smooth",block:"start",inline:"nearest"}));
        return true;
      }
      return false;
    };
    tabs.forEach((tab,index)=>{
      tab.addEventListener("click",()=>activate(tab.dataset.tab));
      tab.addEventListener("keydown",event=>{
        if(!["ArrowLeft","ArrowRight","Home","End"].includes(event.key))return;
        event.preventDefault();
        let next=index;
        if(event.key==="ArrowRight")next=(index+1)%tabs.length;
        if(event.key==="ArrowLeft")next=(index-1+tabs.length)%tabs.length;
        if(event.key==="Home")next=0;
        if(event.key==="End")next=tabs.length-1;
        activate(tabs[next].dataset.tab,true);
      });
    });
    if(!activateFromHash())activate(tabs[0].dataset.tab);
    window.addEventListener("hashchange",activateFromHash);
    if(window.Shopify&&window.Shopify.designMode){
      document.addEventListener("shopify:block:select",event=>{
        const block=event.target.closest("[data-tab]");
        if(!block||!root.contains(block))return;
        activate(block.dataset.tab);
      });
    }
  };
  const initAll=()=>document.querySelectorAll("[data-topfinel-product-tabs]").forEach(init);
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",initAll,{once:true});
  else initAll();
  document.addEventListener("shopify:section:load",event=>{
    const root=event.target.querySelector("[data-topfinel-product-tabs]");
    if(root)init(root);
  });
})();
